export default __webpack_public_path__ + "static/media/drawing-woman12-focusfill.061110a1.svg";